import { Component, Inject, Optional, ViewChild, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { FullCalendarComponent } from '@fullcalendar/angular';

import dayGridPlugin from '@fullcalendar/daygrid';
import timeGrigPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import esLocale from '@fullcalendar/core/locales/es';

import { MatSnackBar } from '@angular/material/snack-bar';
import { AppointmentService } from '../../services/appointment.service';

import * as moment from 'moment';
import { AppSettings } from '../../app.settings';

export interface UsersData {
  name: string;
  id: number;
}

@Component({
  selector: 'app-cancel-reassign-appointment',
  templateUrl: './cancel-reassign-appointment.component.html',
  styleUrls: ['./cancel-reassign-appointment.component.css']
})

export class CancelReassignAppointmentComponent implements OnInit {
  @ViewChild('calendar') calendarComponent: FullCalendarComponent;

  calendarPlugins = [dayGridPlugin, timeGrigPlugin, interactionPlugin];
  action: string;
  appointment: any;
  calendarInit: boolean;
  api: any;

  constructor(
    public dialogRef: MatDialogRef<CancelReassignAppointmentComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: UsersData,
    private appointmentService: AppointmentService,
    private snackBar: MatSnackBar) {
    this.appointment = { ...data };
    this.appointment.cancelNote =""
    this.appointment.reassign = false;
    this.action = this.appointment.action;
    this.calendarInit = false;
  }

  ngOnInit() {
    setTimeout(() => {
      this.render();
    }, 100);
  }

  render(response?: any) {
    this.api = this.calendarComponent.getApi();
    this.api.setOption('header', {
      left: 'title',
      center: '',
      right: 'prev, next'
    });
    this.api.setOption('timeZone', 'locale');
    this.api.setOption('locale', esLocale);
    this.api.setOption('eventLimit', true);
    this.api.setOption('eventLimit', 2);
    this.api.setOption('eventLimitText', 'turnos');
    this.api.setOption('allDaySlot', false);
    this.api.setOption('eventTimeFormat', {
      hour: '2-digit',
      minute: '2-digit'
    });

    if (response) {
      this.api.setOption('minTime', response.minTime);
      this.api.setOption('maxTime', response.maxTime);
      this.api.setOption('firstDay', response.firstDay);
      this.api.setOption('businessHours', {
        daysOfWeek: response.daysOfWeek,
        startTime: response.minTime,
        endTime: response.maxTime
      });
    }

    this.api.render();
  }

  snackBarMessage(msg: any, duration: any) {
    this.snackBar.open(msg, '', {
      duration: duration, panelClass: ['blue-snackbar']
    });
  }

  initCalendar() {
    this.appointmentService.getBySectionalTypeAndOfficeId(this.appointment.sectionalType.id, this.appointment.office.id).subscribe((response: any) => {
      const url = AppSettings.API_ENDPOINT;
      const thisFunctions = this;
      this.api.addEventSource({
        url: `${url}/appointment/calendar/sectionalType/${this.appointment.sectionalType.id}/office/${this.appointment.office.id}/available`,
        type: 'GET',
        cache: true,
        extraParams: {
          unlimited_period: true // quita el límite de máximo día de turnos configurado
        },
        failure: function (e: any) {
          const xhrResponse = JSON.parse(e.xhr.response);
          const message = xhrResponse && xhrResponse.status === 409 ?
            xhrResponse.message : 'Se produjo un error al cargar los turnos disponibles.';

          thisFunctions.snackBarMessage(message, 5000);
        },
        color: 'seaGreen',
        textColor: 'white'
      });
      this.render(response);
      this.calendarInit = true;
    }, (e: any) => {
      if (e.status === 409) {
        this.snackBarMessage(e.error.message, 5000);
      } else {
        this.snackBarMessage('Ocurrio un problema', 5000);
      }
    });
  }

  handleDateClick(calDate) {
    this.snackBarMessage('Día sin turnos', 5000);
  }

  eventClicked(calDate) {
    // Fixeo las fechas porque el calendar las devuelve mal, les aplico el timezone del server
    this.appointment.startIso = calDate.event.start.toISOString().replace('Z', '-03:00');
    this.appointment.endIso = calDate.event.end.toISOString().replace('Z', '-03:00');

    // Genero las fechas con la hora del urno y zona actual
    this.appointment.dateFrom = moment(calDate.event.start.toISOString().split('T')[0]).set('hour', calDate.event.start.getUTCHours()).set('minute', calDate.event.start.getUTCMinutes());
    this.appointment.dateTo = moment(calDate.event.end.toISOString().split('T')[0]).set('hour', calDate.event.end.getUTCHours()).set('minute', calDate.event.end.getUTCMinutes());
  }

  reassignToggle(event) {
    if (event.checked && !this.calendarInit) {
      this.initCalendar();
    }
  }

  doAction() {
    if (this.appointment.cancelNote) {
      this.dialogRef.close({ event: 'Accept', data: this.appointment });
    } else {
      this.snackBarMessage('¡El motivo de cancelación es obligatorio!', 5000);
    }
  }

  closeDialog() {
    this.dialogRef.close({ event: 'Cancel' });
  }
}
